// @flow

import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import { useUrlParams } from 'shared_data/providers/url/useUrlParams';
import { canUserAccessRoute } from '@riseart/fe-utils';
import { useLocale } from 'shared_services/redux/hooks/useLocale';
import { selectAclRole } from 'shared_services/redux/selectors/auth';
import { selectUserProperty } from 'shared_services/redux/selectors/user';
import { isRoutedUrl } from 'shared_services/riseart/utils/Utils';
import { authRedirect } from 'shared_services/riseart/utils/AuthUtils';
import { application as CONFIG_APP } from 'Config';

/**
 * useForwardUrlAcl
 *
 * @param {string} forwardUrl
 * @returns boolean
 */
export function useForwardUrlAcl(forwardUrl?: string): boolean {
  const aclRole = useSelector(selectAclRole);
  const isUserLoggedIn = useSelector(selectUserProperty('id'));
  const locale = useLocale();
  const { translatedLocation: location } = useUrlParams();
  const history = useHistory();
  const isRedirectedByForwardUrl = useMemo(() => {
    const queryParameters = queryString.parse(location.search);
    const url = queryParameters.forward || forwardUrl;
    // $FlowFixMe
    const forwardRouterConfig = url && isRoutedUrl(url);
    const forwardUrlAclRoles =
      (forwardRouterConfig && forwardRouterConfig.acl && forwardRouterConfig.acl.roles) || false;

    if (
      isUserLoggedIn &&
      (!url ||
        canUserAccessRoute(
          aclRole,
          forwardUrlAclRoles,
          CONFIG_APP.acl.rolesHierarchy,
          // $FlowFixMe
          queryParameters.role ? queryParameters.role.split(',') : null,
        ))
    ) {
      authRedirect({ ...queryParameters, forward: url }, history, locale, location);
      return true;
    }

    return false;
  }, [aclRole, forwardUrl, history, isUserLoggedIn, locale, location]);

  return isRedirectedByForwardUrl;
}
